// ═══════════════════════════════════════════════════════════════════════════
// Llaves de acceso — la capa de datos
//
// El camino de rescate: entrar sin correo y sin contraseña. Ver
// AUTENTICACION.md §2 y la migración 0031.
//
// La llave EN CLARO existe en una sola respuesta y nunca más. Aquí no se
// guarda en ningún lado: la pantalla la enseña una vez y quien la recibe la
// anota. Meterla en `localStorage` "para que no se pierda" convertiría el
// rescate en el agujero.
// ═══════════════════════════════════════════════════════════════════════════

import { supabase } from "./sesion.js";
import { configSupabase } from "./config.js";

/** Genera una llave. La devuelve EN CLARO — es la única vez que se puede ver. */
export async function crearLlave(etiqueta) {
  const { data, error } = await supabase.rpc("crear_llave_acceso",
    { p_etiqueta: etiqueta || null });
  if (error) throw new Error(error.message);
  return data;                     // { id, llave, prefijo }
}

/** Las mías, con sus metadatos. El hash nunca sale de la base. */
export async function misLlaves() {
  const { data, error } = await supabase.from("access_key")
    .select("id, prefijo, etiqueta, created_at, last_used_at, revoked_at")
    .order("created_at", { ascending: false });
  if (error) throw new Error(error.message);
  return data || [];
}

export async function revocarLlave(id) {
  const { data, error } = await supabase.rpc("revocar_llave_acceso", { p_id: id });
  if (error) throw new Error(error.message);
  return data;
}

/**
 * Entrar con una llave.
 *
 * Dos pasos, y los dos importan:
 *
 *   1. la función de borde valida la llave y pide a Supabase un token de un
 *      solo uso. La llave no sale de esa petición.
 *   2. el navegador canjea ese token por la sesión con `verifyOtp`, que la
 *      guarda donde el resto de la app la espera. No la fabricamos nosotros.
 *
 * Si el segundo paso no se hiciera así, tendríamos una sesión que Supabase no
 * reconoce y la RLS no sabría quién eres.
 */
export async function entrarConLlave(llave) {
  const { url, anonKey } = configSupabase();

  const r = await fetch(`${url}/functions/v1/entrar-con-llave`, {
    method: "POST",
    headers: { "Authorization": `Bearer ${anonKey}`, "Content-Type": "application/json" },
    body: JSON.stringify({ llave: String(llave || "").trim() }),
  });

  if (!r.ok) {
    // El servidor contesta lo mismo para toda llave que no sirve: no existe,
    // está revocada, o está mal escrita. Aquí se respeta ese silencio.
    throw new Error("Esa llave no sirve. Revisa que la hayas copiado completa.");
  }

  const { token_hash } = await r.json();
  const { data, error } = await supabase.auth.verifyOtp({
    token_hash, type: "magiclink",
  });
  if (error) throw new Error(error.message);
  return data.session;
}
